import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appOnlyAlphabetic]'
})
export class OnlyAlphabetic {
    constructor(private _el: ElementRef) {
    }
    @HostListener('input', ['$event']) onInputChange(event) {
        let initalValue = '';  
        if (this._el.nativeElement.localName == "sirius-textbox") { 
            initalValue = this._el.nativeElement.children[0].value;
            this._el.nativeElement.children[0].value = initalValue.replace(/[^a-zA-ZığüşöçİĞÜŞÖÇ\-\s]/g, '');
            if (initalValue !== this._el.nativeElement.children[0].value) {
                event.stopPropagation();
            }
        }
        else { 
            initalValue = this._el.nativeElement.value;  
            this._el.nativeElement.value = initalValue.replace(/[^a-zA-ZığüşöçİĞÜŞÖÇ\-\s]/g, '');
            if (initalValue !== this._el.nativeElement.value) {
                event.stopPropagation();
            }
        }
    }
   
    @HostListener('paste', ['$event'])
    onPaste(event: Event) {
        setTimeout(() => {
            const input = (<HTMLInputElement>event.target);
            input.value = input.value.replace(/[^a-zA-ZığüşöçİĞÜŞÖÇ\-\s]/g, '');
        });
    }

}